import { TripType } from "./tripType";

export class LogEntry {
  id?: string;
  date: string = new Date().toISOString();
  type: TripType = TripType.Walk;
  distance: number = 0;
  leg: string | null = null;
  notes: string | null = null;

  constructor(data : LogEntry) {
    Object.assign(this, data);
  }
}